import { formatDate } from 'utils/helpers/date'
import ActionCellRenderer from './actionCellRenderer'
import {
  ColDef,
  ICellRendererParams,
  ValueFormatterParams,
} from '@ag-grid-community/core'

export type StoreFormData = {
  storeName: string
  storeId: string
  invoicePrefixCode: string
  talabatId?: string
  instashopIdentifier?: string
  oosThreshold: string
  lastMile: (typeof LAST_MILES)[number]
}

/**
 ** LAST MILES
 */
export const LAST_MILES = ['Loginext', 'Fareye'] as const

export const storeFormFields = {
  STORE_NAME: { key: 'storeName', label: 'Store Name' },
  STORE_ID: { key: 'storeId', label: 'Store ID' },
  STORE_IS_ACTIVE: { key: 'isActive', label: 'Active' },
  STORE_INSTASHOP_IDENTIFIER: {
    key: 'instashopIdentifier',
    label: 'Instashop Identifier',
  },
  STORE_LAST_MILE: {
    key: 'lastMile',
    label: 'Order Last Mile',
  },
  STORE_TALABAT_ID: { key: 'talabatId', label: 'Talabat Id' },
  STORE_OOS_THRESHOLD: { key: 'oosThreshold', label: 'OOS Threshold' },
  STORE_INVOICE_PREFIX_CODE: {
    key: 'invoicePrefixCode',
    label: 'Invoice Prefix Code',
  },
} as const

export const getColumns = (
  isEditor: boolean,
  getStoreToDelete: (params: ICellRendererParams) => void,
) =>
  [
    {
      headerName: storeFormFields.STORE_NAME.label,
      field: storeFormFields.STORE_NAME.key,
      minWidth: 200,
    },
    { headerName: 'ID', field: '_id', minWidth: 120 },
    {
      headerName: storeFormFields.STORE_TALABAT_ID.label,
      field: storeFormFields.STORE_TALABAT_ID.key,
      valueFormatter: (params: ValueFormatterParams) =>
        params.value ? params.value : '-',
    },
    {
      headerName: storeFormFields.STORE_OOS_THRESHOLD.label,
      field: storeFormFields.STORE_OOS_THRESHOLD.key,
      valueFormatter: (params: ValueFormatterParams) =>
        params.value ? params.value : '-',
    },
    { headerName: 'User', field: 'userName' },
    {
      headerName: 'Creation Date',
      field: 'createdAt',
      valueFormatter: (params: ValueFormatterParams) =>
        formatDate(params.value, { includeTime: true }),
    },
    {
      headerName: 'Last Mile',
      field: 'lastMile',
    },
    {
      headerName: 'Status',
      field: 'isActive',
      cellRenderer: (params: ICellRendererParams) => {
        return params?.value === true
          ? 'Active'
          : params?.value === false
            ? 'Inactive'
            : '-'
      },
    },
    {
      hide: !isEditor,
      headerName: 'Action',
      field: 'save',
      minWidth: 200,
      cellRenderer: (params: ICellRendererParams) => (
        <ActionCellRenderer
          params={params}
          isEditor={isEditor}
          getStoreToDelete={getStoreToDelete}
        />
      ),
    },
  ] as ColDef[]
